<template>
  <div>
    <system-bar class="ancho-maximo" />
    <TheAppBar :color="color" :flat="flat" class="ancho-maximo" />
    <!-- <the-hero-section /> -->
    <v-main class="pa-0 ancho-maximo">
      <router-view />
    </v-main>
    <TheFooter class="ancho-maximo" />
    <btn-whatsapp />
  </div>
</template>

<script>
export default {
  components: {
    SystemBar: () => import("@/components/TheSystemBar"),
    TheAppBar: () => import("@/components/TheAppBar"),
    // TheHeroSection: () => import("@/components/TheHeroSection"),
    TheFooter: () => import("@/components/TheFooter"),
    // BtnBackToTop: () => import("@/components/BtnBackToTop"),
    BtnWhatsapp: () => import("@/components/BtnWhatsapp")
  },
  data: () => ({
    color: "white",
    flat: true
  }),
  created() {
    const top = window.pageYOffset || 0;
    if (top <= 20) {
      //this.color = "white"; //transparent
      this.flat = true;
    }
  }
};
</script>

<style lang="sass">
.extra-padding
  padding-bottom: 76px !important
  padding-top: 46px !important
  @media screen and (max-width: 959px)
    padding-top: 38px !important
    padding-bottom: 38px !important
.v-parallax__content
  padding: 0 !important
.ancho-maximo
  max-width: 2024px
</style>
